export const firebaseConfig = {
    apiKey: "AIzaSyDRTfNXwoWhvmDwMeNK8fbP6yjd7fBoG7o",
    authDomain: "trendico-intranet.firebaseapp.com",
    databaseURL: "https://trendico-intranet-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "trendico-intranet",
    storageBucket: "trendico-intranet.appspot.com",
    messagingSenderId: "424655067104",
    appId: "1:424655067104:web:e282bd1401e1041ce6fd85",
    measurementId: "G-QN1CJPT9Y0"
  };